import { Box, Typography } from '@mui/material';

/** 有图标时标题区固定宽度（px），与数值列对齐 */
const DATA_LIST_ITEM_TITLE_WIDTH_WITH_ICON_PX = 180;
/** 无图标时标题区固定宽度（px） */
const DATA_LIST_ITEM_TITLE_WIDTH_WITHOUT_ICON_PX = 220;

// 数据分析卡片组件
export default function DataListItem(props: {
    // icon
    icon?: JSX.Element;
    // 标题
    title: string;
    // 数量
    num: string;
    // 是否加粗
    isBold?: boolean;
}) {
    // 标题区宽度：有图标 180px，无图标 220px
    const titleWidthPx = props.icon
        ? DATA_LIST_ITEM_TITLE_WIDTH_WITH_ICON_PX
        : DATA_LIST_ITEM_TITLE_WIDTH_WITHOUT_ICON_PX;

    return (
        <Box display={'flex'} alignItems={'center'} justifyContent={'flex-start'} flexWrap={'wrap'}>
            {props.icon && (
                <Box marginRight={'0.5rem'}>
                    {props.icon}
                </Box>
            )}
            <Typography
                marginRight={'0.5rem'}
                variant={props.isBold ? 'subtitle1' : 'body1'}
                sx={{
                    width: `${titleWidthPx}px`,
                    flexShrink: 0,
                }}>
                {props.title}
            </Typography>
            <Typography
                variant={props.isBold ? 'subtitle1' : 'body1'}
                sx={{
                    flex: 1,
                    textAlign: 'right'
                }}>
                {props.num}
            </Typography>
        </Box>

    )
}

